/** Pieces shared by the registry pages (proposal §2). */
import { useQuery } from '@tanstack/react-query';
import type { RegistryLookups, SubjectListItem, SubjectRoleResponse } from '@k-management/shared';
import { apiRequest } from '../../lib/api.js';

export const registryKeys = {
  all: ['subjects'] as const,
  lookups: ['subjects', 'lookups'] as const,
  subject: (id: string) => ['subjects', id] as const,
  history: (id: string) => ['subjects', id, 'history'] as const,
  requests: ['unlock-requests'] as const,
};

export function useRegistryLookups() {
  return useQuery({
    queryKey: registryKeys.lookups,
    queryFn: () => apiRequest<RegistryLookups>('/subjects/lookups'),
    staleTime: 60_000,
  });
}

const ROLE_COLORS: Record<string, string> = { C: 'role-c', F: 'role-f', D: 'role-d', B: 'role-b' };

export function RoleBadge({
  role,
  withCode = false,
}: {
  role: SubjectRoleResponse;
  withCode?: boolean;
}) {
  return (
    <span
      className={`role-badge ${ROLE_COLORS[role.roleCode] ?? 'role-x'}${role.active ? '' : ' off'}`}
    >
      {role.roleName}
      {withCode && <span className="code"> {role.code}</span>}
    </span>
  );
}

export function StatePill({ subject }: { subject: Pick<SubjectListItem, 'active' | 'complete'> }) {
  if (!subject.complete) return <span className="pill warn">Da completare</span>;
  return subject.active ? (
    <span className="pill ok">Attivo</span>
  ) : (
    <span className="pill muted">Disattivato</span>
  );
}

export function lookupLabel(
  list: { code: string; description: string }[] | undefined,
  code?: string | null,
): string {
  if (!code) return '';
  return list?.find((entry) => entry.code === code)?.description ?? code;
}
